<template>
    <div class="theme" v-if="filteredTileList && filteredTileList.length > 0" :key="selectedSeason">
        <div class="theme-navigation-container">
            <ul id="tileNav" class="theme-navigation">
                <li v-bind:key="index" v-for="(tile,index) in filteredTileList" :data-menuanchor="tile.id">
                    <a :href="'#' + tile.id"><i class="fas fa-circle"></i></a>
                </li>
            </ul>
            <ul id="currentCollectionMoods" :key="currentTileId"
                v-if="currentCollectionMoods && currentCollectionMoods.length > 0 && canRead('collection_moods')"
                class="sub-theme-navigation">
                <li v-bind:key="index" v-for="(tile,index) in currentCollectionMoods" class="my-2">
                    <a :href="'/theme/' + selectedSeason + '/' + currentTileId + '#'  + tile.id + '/' + selectedSeason">
                        <img ref="tileImage" style="max-width: 60px;" :src="imageResource(tile.tile.value.image, 60)"
                             alt="i
                             mage"/>
                    </a>
                </li>
            </ul>
            <ul v-if="$route.params.sub" class="theme-navigation">
                <li class="active">
                    <a :href="'/theme/' + selectedSeason + '#' + $route.params.sub"><i class="fal fa-undo"></i></a>
                </li>
            </ul>
        </div>
        <full-page ref="fullpage" :options="options" id="fullpage">
            <pb-theme-page :tile="tile" v-bind:key="index" v-for="(tile,index) in filteredTileList"
                           class="section fp-auto-height-responsive"/>
        </full-page>
    </div>
</template>

<script>
    import ContentAPI from "@shared/_api/cms/content";
    import ThemePage from "./ThemePage";
    import {mapGetters, mapState} from "vuex";

    export default {
        name: 'Theme',
        components: {
            'pb-theme-page': ThemePage
        },
        data() {
            return {
                tileList: [],
                selectedSeason: null,
                collectionMoods: [],
                currentTileId: undefined,
                currentTile: undefined,
                options: {
                    licenseKey: '4F5E0357-FEC447CA-B911DF69-4A231B6D',
                    navigation: true,
                    normalScrollElements: ".dropdown .nav-categories, .dropdown .cart, .dropdown .sample-items, .dropdown-category-menu-scroller",
                    anchors: [],
                    paddingTop: this.isMobile ? '60px' : '',
                    menu: '#tileNav',
                    afterLoad: this.afterLoad
                },
            }
        },
        mounted() {
            this.fetchTiles(this.$route.params.season, this.$route.params.sub, this.$route.hash ? this.$route.hash.split('#')[1] : null);

        },
        methods: {
            onChangeSeason() {
                this.$router.push({
                    name: 'theme',
                    params: {season: this.selectedSeason === 'winter' ? 'summer' : 'winter'}
                });
            },
            mapCollectionMoods(designShopTiles, collectionMoods) {
                for (let i = 0; i < designShopTiles.length; i++) {
                    let collectionMoodChildren = designShopTiles[i].collection_mood && designShopTiles[i].collection_mood.value ? designShopTiles[i].collection_mood.value : null;

                    if (collectionMoodChildren) {
                        for (let z = 0; z < collectionMoodChildren.length; z++) {
                            let currentChild = collectionMoodChildren[z];
                            let collectionMood = collectionMoods.find(collectionMood => Number(currentChild.id) === Number(collectionMood.id));
                            collectionMood = {...collectionMood, sort: currentChild['sort']};
                            designShopTiles[i].collection_mood.value[z] = collectionMood;
                        }
                    }
                }
            },
            fetchTiles(season, subId, currentTileId) {
                this.selectedSeason = season ? season : 'summer';

                ContentAPI.fetchListByName("design-shop").then((designShopTileList) => {
                    ContentAPI.fetchListByName("collection_moods").then((list) => {


                        let designShopTileListBySeason = designShopTileList.filter(tile => (tile.tile ? tile.tile.value.season === this.selectedSeason : true));

                        this.mapCollectionMoods(designShopTileListBySeason, list);

                        if (subId) {
                            let parentDesignTile = designShopTileListBySeason.find(tile => {
                                return Number(tile.id) === Number(subId);
                            });
                            if (parentDesignTile && parentDesignTile.collection_mood) {
                                this.tileList = this.$_.orderBy(parentDesignTile.collection_mood.value, ['sort'],['asc']);
                            }
                        } else {
                            this.tileList = designShopTileListBySeason;
                        }

                        this.options.anchors = this.filteredTileList.map(tile => {
                            return tile.id + "";
                        });

                        if (currentTileId) {
                            this.currentTileId = currentTileId;
                            this.currentTile = this.filteredTileList.find(tile => currentTileId == tile.id);
                        } else {
                            this.currentTile = this.filteredTileList[0];
                            this.currentTileId = this.filteredTileList[0].id;
                        }


                        // ArticleApi.cardList().then((cards) => {
                        //     var myMap = new Map();
                        //
                        //     for(let j = 0; j < cards.length; j++) {
                        //         myMap.set( cards[j].id,  cards[j].name);
                        //     }
                        //     ArticleApi.cardArticleList().then((articleList) => {
                        //         function searchInList(colorId, cardId) {
                        //             for(let a = 0; a < articleList.length; a++) {
                        //
                        //                 if(articleList[a].cardColorId == colorId && articleList[a].cardId == cardId) {
                        //                     return true;
                        //                 }
                        //             }
                        //
                        //             return false;
                        //         }
                        //
                        //         function checkForBrokenArticles(pins, name) {
                        //             if(pins) {
                        //                 for(let z = 0; z < pins.length; z++) {
                        //                     for(let y = 0; y < pins[z].articleList.length; y++) {
                        //                         if(pins[z].articleList[y].cardId && !searchInList(pins[z].articleList[y].colorId, pins[z].articleList[y].cardId)) {
                        //                             console.log(myMap.get(pins[z].articleList[y].cardId) + ";" +pins[z].articleList[y].label + ";" + pins[z].articleList[y].colorId + ";" + name);
                        //                         }
                        //                     }
                        //                 }
                        //             }
                        //
                        //         }
                        //
                        //         for(let i = 0; i < tileList.length; i++) {
                        //             checkForBrokenArticles(tileList[i].tile.value.pinList, tileList[i].identifier.value);
                        //
                        //         }
                        //
                        //         for(let i = 0; i < list.length; i++) {
                        //             checkForBrokenArticles(list[i].tile.value.pinList, list[i].identifier.value);
                        //
                        //         }
                        //     });
                        //
                        // })

                    });
                })
            }
        },
        computed: {
            ...mapState("modal", ['openModals']),
            ...mapState("account", ["user"]),
            ...mapGetters('account', ['canRead']),
            ...mapGetters('media', ['isMobile']),
            currentCollectionMoods: function () {
                if (this.currentTile && this.currentTile.collection_mood) {
                    return this.$_.orderBy(this.currentTile.collection_mood.value, ['sort'],['asc']);

                }
                return [];
            },
            filteredTileList: function () {

                let tileList = this.tileList.filter(tile => {
                    return (tile.visibility ? tile.visibility.value : true);
                });

                tileList.sort((a, b) => {
                    let sortA = a.order ? Number(a.order.value) : 0;
                    let sortB = b.order ? Number(b.order.value) : 0;

                    return (sortA > sortB) ? 1 : ((sortB > sortA) ? -1 : 0)
                });

                return tileList;
            }
        },
        beforeRouteUpdate(to, from, next) {

            if (to.hash) {
                this.currentTileId = to.hash.split('#')[1];
                this.currentTile = this.filteredTileList.find(tile => to.hash.split('#')[1] == tile.id);
            }

            if (!to.hash && !to.params.sub) {
                this.fetchTiles();
            }

            next();
        },
        watch: {
            openModals: function (val) {
                this.$refs.fullpage.api.setAllowScrolling(!val.length > 0);
            }
        }
    }

</script>

<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .fp-auto-height {
        height: auto !important;
    }

    #fullpage {
        @include media-breakpoint-down(md) {
            margin-top: -60px;
        }

    }

    #season-switch {
        .active {
            color: #1b1e21;
        }
    }

    .theme {
        overflow: hidden;
        position: relative;
        .season-switch {
            margin-left: 20px;
            margin-right: 20px;
            background: rgba(255, 255, 255, 0.8);
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
            border: none;
            width: 80px;
            font-size: 12px;

            &:hover {
                box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
                background: #efefeb;
            }

            &:disabled {
                color: white;
                background: #4A4B4D;
                cursor: not-allowed;
                filter: alpha(opacity=65);
                -webkit-box-shadow: none;
                box-shadow: none;
                opacity: .65;

                &:hover {
                    background: #4A4B4D;
                    opacity: .65;
                }
            }
        }

        .section {
            overflow: hidden;
        }

        .theme-navigation-container {
            position: fixed;
            z-index: 10;
            top: 20%;
            left: 20px;
            @include media-breakpoint-down(md) {
                left: 10px;
            }

            .sub-theme-navigation {
                padding: 15px 10px;
                list-style: none;
                width: 80px;
                background: rgba(255, 255, 255, 0.8);
                box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
                margin: 20px;

                img {
                    height: 100%;
                    width: 100%;
                    margin: auto;
                    object-fit: cover;

                    &:hover {
                        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
                    }
                }
            }

            .theme-navigation {
                padding: 15px 30px;
                list-style: none;
                width: 80px;
                background: rgba(255, 255, 255, 0.8);
                box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
                margin: 20px;


                li {
                    opacity: 0.2;
                    margin: 0;
                    padding: 4px;

                    &.active {
                        opacity: 1;
                    }
                }
            }
        }

    }
</style>